import { Util } from './../_classes/util';
import { MatTableDataSource } from '@angular/material/table';
import { catchError, take, tap } from 'rxjs/operators';
import { Subject, Observable, timer, EMPTY } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { RestService } from '../_servicos/rest.service';
import { ServidorService } from '../_servicos/servidor.service';
import { ModalAlertaService } from '../shared/modal-alerta.service';
import { Provimento } from '../_classes/provimento';
import { ModalAjudaService } from '../shared/modal-ajuda.service';
import { EnvService } from '../_servicos/env.service';
import { UtilLogAcessoSistema } from '../_classes/util-log-acesso-sistema';

@Component({
  selector: 'app-evolucao-carreira',
  templateUrl: './evolucao-carreira.component.html',
  styleUrls: ['./evolucao-carreira.component.scss'],
})
export class EvolucaoCarreiraComponent implements OnInit {
  private readonly recurso: string = 'evolucao-carreira'; //mesmo que a rota
  carregando = false;
  displayedColumns: string[] = ['periodo', 'codigo', 'ativa', 'referencia'];

  //servidor$: Observable<Servidor>;
  //servidor: Servidor = new Servidor();

  erros$ = new Subject<boolean>();
  dataSource$: Observable<Provimento[]>;
  dataSource: MatTableDataSource<Provimento>;

  itensAjuda = [
    {
      titulo: 'Provimento',
      texto: 'Indica de qual provimento está sendo listada a carreira',
    },
    {
      titulo: 'Período',
      texto: 'Período ao qual a evolução de carreira se refere',
    },
    { titulo: 'Código', texto: 'Código da carreira' },
    { titulo: 'Ativa', texto: 'Indica se está ativa' },
    {
      titulo: 'Ref. Salarial',
      texto:
        'Indica a qual referência salarial aquele item da carreira se referencia',
    },
  ];

  private t: any;

  ngOnDestroy() {
    if (this.t) {
      this.t.unsubscribe();
    }
  }

  constructor(
    private service: RestService,
    private servService: ServidorService,
    private alertService: ModalAlertaService,
    private ajudaService: ModalAjudaService,
    private env: EnvService
  ) {}

  periodo(dI: Date, dF: Date) {
    return Util.periodoMesAbreviado(dI, dF);
  }

  dataStr(d: Date) {
    return Util.dataMesAbrev(d);
  }

  ngOnInit() {
    this.atualizar();
  }
  /*
  executarAoCarregarServidor(x: Servidor) {
    this.servidor = new Servidor(x);
  }*/

  executarAoCarregarDatasource(x: Provimento[]) {
    x.forEach((item) => {
      item.DSCarreira$ = this.service
        .listarCarreira(this.env.servidor.idServidor)
        .pipe(
          take(1),
          catchError((e) => {
            this.handleError(e);
            return EMPTY;
          })
        );
    });

    this.dataSource = new MatTableDataSource<Provimento>(x);

    this.carregando = false;
  }

  atualizar() {
    this.carregando = true;
    this.t = timer(20000).subscribe((v) => {
      if (this.carregando) {
        this.carregando = false;
        this.handleError(
          'Excedido tempo de carregamento (' + this.constructor.name + ')'
        );
      }
    });

    if (this.env.servidor) {
      this.listar();
    } else {
      //this.servService.getServidorComFuncao(() => {this.listar();});
      this.servService.getServidorComFuncao2().then(() => this.listar());
    }
  }

  listar() {
    UtilLogAcessoSistema.registrarAcessoAoRecurso(
      this.recurso,
      this.env.servidor.idServidor,
      this.service
    );

    this.dataSource$ = this.service
      .listarProvimento(this.env.servidor.idServidor)
      .pipe(
        tap((a) => this.executarAoCarregarDatasource(a)),
        take(1),
        catchError((e) => {
          this.handleError(e);
          return EMPTY;
        })
      );
  }

  /*
  atualizar() {
    this.carregando = true;
    this.t = timer(20000).subscribe((v) => {
      if (this.carregando) {
        this.carregando = false;
        this.handleError(
          'Excedido tempo de carregamento (' + this.constructor.name + ')'
        );
      }
    });
    this.servidor =
      this.servService.getServidorAtualRedirecionando('evolucao-carreira');

    this.servidor$ = this.servService.getServidor().pipe(
      tap((x) => this.executarAoCarregarServidor(x)),
      take(1),
      catchError((e) => {
        this.handleError(e);
        return empty();
      })
    );

    if (this.servidor) {
      this.dataSource$ = this.service
        .listarProvimento(this.servidor.idServidor)
        .pipe(
          tap((a) => this.executarAoCarregarDatasource(a)),
          take(1),
          catchError((e) => {
            this.handleError(e);
            return empty();
          })
        );
    }
  }
*/
  mostrarAjudaModal() {
    this.ajudaService.mostrar(this.itensAjuda, '');
  }

  handleError(e: any) {
    this.erros$.next(true);
    this.alertService.mostrarAlertaPerigo(
      'Erro, tente novamente mais tarde',
      e
    );
  }
}
